export const TableHelpers = {
    data() {
        return {
            tableColumns: [
                {
                    title: 'Expediente',
                    type: 'custom-html',
                    key: 'accreditation_applications',
                    modifier: (item) => {
                        return `<a href="/accreditations/applications/${item.id}" target="_blank">${item.record || ''}</a>`;
                    }
                },
                {
                    title: 'Tipo de Acreditacion',
                    type: 'custom-html',
                    key: 'accreditation_applications',
                    modifier: (item) => {
                        return item.accreditation_type.name;
                    }
                },
                {
                    title: 'OEC',
                    type: 'custom-html',
                    key: 'accreditation_applications',
                    modifier: (item) => {
                        return item.organization.name;
                    }
                },
                {
                    title: 'Tipo',
                    type: 'custom-html',
                    key: 'type',
                    modifier: (item) => {
                        return item == 'E' ? 'Evaluacion' : 'Testificacion';
                    }
                },
                {
                    title: 'Codigo',
                    type: 'text',
                    key: 'code',
                },
                {
                    title: 'Fecha de Registro',
                    type: 'custom-html',
                    key: 'date_start',
                    modifier: (item) => {
                        return item;
                    }
                },
            ],
            actionObj: {
                title: this.$t('action'),
                type: 'action',
            }
        }
    },
}